import React from "react";
import AppSideBar from "../nav/AppSideBar";
import AlertFeed from "../alerts/alertFeed";
import PacefiFullScreenSpinner from "../loaders/pacefiFullScreenSpinner";
import CornerCover from "../svgassets/cornerCover";
import MobileTopNav from "../nav/MobileTopNav";

export default class FormFlowWrapper extends React.Component {


    // prevent default on missed drop files

    stopDefaults = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
    }

  render() {
    return (
      <div className="page-wrapper" onDragOver={this.stopDefaults} onDrop={this.stopDefaults}>
        <MobileTopNav />
        <div
          className="columns min-full-screen-height"
        >
          <div
            className="column is-one-fifth has-background-info has-text-light only-desktop no-print"
            style={{ maxWidth: "15em" }}
          >
            <AppSideBar />
          </div>

          <div
            className="column  has-background-white-ter container-formflow"
          >
               <div className="form-flow-wrapper" style={this.props.controlWidth ? {maxWidth: '1000px'} : {}}> 
                    {this.props.children}
                  
              </div>
          </div>
        </div>
        <div id="admin-wrapper-alert-feed">
          <AlertFeed />
        </div>
        {!this.props.noLoader && <PacefiFullScreenSpinner/>}
        <CornerCover
          style={{ zIndex: 2, opacity: 0.2 }}
          className="corner-cover"
        />
      </div>
    );
  }
}
